import {
  BookImageIcon,
  ExternalLinkIcon,
  Grid3X3Icon,
  ImageIcon,
  ImagesIcon,
  InboxIcon,
  LayoutListIcon,
  LinkIcon,
  MapIcon,
  MessageCircleQuestionIcon,
  PlayIcon,
  TypeIcon,
  UserPenIcon,
} from "lucide-vue-next";
import Image from "@page-js/Pages/Page/Editor/Blocks/Image";
import Form from "@page-js/Pages/Page/Editor/Blocks/Form";
import RichText from "@page-js/Pages/Page/Editor/Blocks/RichText";
import Youtube from "@page-js/Pages/Page/Editor/Blocks/Youtube";
import Button from "@page-js/Pages/Page/Editor/Blocks/Button";
import Carousel from "@page-js/Pages/Page/Editor/Blocks/Carousel";
import BigButton from "@page-js/Pages/Page/Editor/Blocks/BigButton";
import QuickButton from "@page-js/Pages/Page/Editor/Blocks/QuickButton";
import ItemButton from "@page-js/Pages/Page/Editor/Blocks/ItemButton";
import GoogleMap from "@page-js/Pages/Page/Editor/Blocks/GoogleMap";
import BusinessHours from "@page-js/Pages/Page/Editor/Blocks/BusinessHours";
import Gallery from "@page-js/Pages/Page/Editor/Blocks/Gallery";
import Faq from "@page-js/Pages/Page/Editor/Blocks/Faq";
import Showcase from "@page-js/Pages/Page/Editor/Blocks/Showcase";
import Introduction from "@page-js/Pages/Page/Editor/Blocks/Introduction";

export const getBlockMeta = (type: string): BlockMeta => {
  return BlockMetas.find((meta) => meta.type === type) || BlockMetas[0];
};

export interface BlockMeta {
  title: string;
  description: string;
  size: "sm" | "md" | "lg";
  icon: object;
  type: string;
  class: any;
}

export const BlockMetas: BlockMeta[] = [
  {
    title: "소개",
    description: "페이지에 소개를 추가하여 사용자로 하여금 페이지의 내용을 이해할 수 있도록 합니다.",
    size: "lg",
    icon: UserPenIcon,
    type: "Introduction",
    class: Introduction,
  },
  {
    title: "이미지",
    description: "페이지에 이미지를 추가하여 보여줍니다.",
    size: "lg",
    icon: ImageIcon,
    type: "Image",
    class: Image,
  },
  {
    title: "이미지 슬라이드",
    description: "페이지에 이미지 슬라이드를 추가하여 여러 이미지를 회전으로 보여줍니다.",
    size: "lg",
    icon: ImagesIcon,
    type: "Carousel",
    class: Carousel,
  },
  {
    title: "폼",
    description: "페이지에 폼을 추가하여 사용자로부터 정보를 입력받을 수 있습니다.",
    size: "md",
    icon: InboxIcon,
    type: "Form",
    class: Form,
  },
  {
    title: "영업 시간",
    description: "페이지에 영업 시간을 추가하여 사용자로 하여금 영업 시간을 확인할 수 있도록 합니다.",
    size: "lg",
    icon: InboxIcon,
    type: "BusinessHours",
    class: BusinessHours,
  },
  {
    title: "버튼",
    description: "페이지에 버튼을 추가하여 사용자로 하여금 특정 동작을 할 수 있도록 합니다.",
    size: "sm",
    icon: LinkIcon,
    type: "Button",
    class: Button,
  },
  {
    title: "배너 버튼",
    description: "이미지를 포함하는 큰 버튼을 추가하여 사용자로 하여금 특정 동작을 할 수 있도록 합니다.",
    size: "lg",
    icon: ExternalLinkIcon,
    type: "BigButton",
    class: BigButton,
  },
  {
    title: "아이템 버튼",
    description: "페이지에 아이템 버튼을 추가하여 사용자로 하여금 특정 동작을 할 수 있도록 합니다.",
    size: "lg",
    icon: LayoutListIcon,
    type: "ItemButton",
    class: ItemButton,
  },
  {
    title: "퀵 링크 3X3",
    description: "페이지에 퀵 링크 3X3를 추가하여 사용자로 하여금 특정 동작을 할 수 있도록 합니다.",
    size: "lg",
    icon: Grid3X3Icon,
    type: "QuickButton",
    class: QuickButton,
  },
  {
    title: "쇼케이스",
    description: "페이지에 쇼케이스를 추가하여 사용자로 하여금 특정 동작을 할 수 있도록 합니다.",
    size: "lg",
    icon: BookImageIcon,
    type: "Showcase",
    class: Showcase,
  },
  {
    title: "텍스트",
    description: "페이지에 텍스트를 추가하여 보여줍니다.",
    size: "md",
    icon: TypeIcon,
    type: "RichText",
    class: RichText,
  },
  {
    title: "갤러리",
    description: "페이지에 이미지 갤러리를 추가하여 사용자에게 여러 이미지를 보여줍니다.",
    size: "lg",
    icon: ImagesIcon,
    type: "Gallery",
    class: Gallery,
  },
  {
    title: "유튜브",
    description: "페이지에 유튜브를 추가하여 사용자로 하여금 동영상을 시청할 수 있도록 합니다.",
    size: "lg",
    icon: PlayIcon,
    type: "Youtube",
    class: Youtube,
  },
  {
    title: "지도(구글)",
    description: "페이지에 구글 지도를 추가하여 사용자로 하여금 지도를 확인할 수 있도록 합니다.",
    size: "lg",
    icon: MapIcon,
    type: "GoogleMap",
    class: GoogleMap,
  },
  {
    title: "FAQ",
    description: "페이지에 FAQ를 추가하여 사용자로 하여금 자주 묻는 질문을 확인할 수 있도록 합니다.",
    size: "lg",
    icon: MessageCircleQuestionIcon,
    type: "Faq",
    class: Faq,
  },
];
